import { Box, Text } from '@rbilabs/universal-components';

export const Container = Box.withConfig({
  width: 'full',
  alignItems: 'center',
  justifyContent: 'center',
});

export const Heading = Text.withConfig({
  variant: 'headerOne',
  margin: 0,
  padding: 0,
});

export const Content = Text.withConfig({
  variant: 'copyOne',
  textAlign: 'center',
  marginY: '$4',
});
